export default __webpack_public_path__ + "static/media/remove-tag.4d41d68f.svg";